import { render, staticRenderFns } from "./Centre.vue?vue&type=template&id=f3f914a4&scoped=true&"
import script from "./Centre.vue?vue&type=script&lang=js&"
export * from "./Centre.vue?vue&type=script&lang=js&"
import style0 from "./Centre.vue?vue&type=style&index=0&id=f3f914a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f914a4",
  null
  
)

export default component.exports